// eslint-disable-next-line no-restricted-imports
import { Checkbox, FormControlLabel, Tooltip } from "@material-ui/core";
import { ChangeEvent, MouseEventHandler, ReactNode } from "react";

export interface SwitchInputProps {
  id?: string;
  toolTip?: string;
  disabled?: boolean;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  label: ReactNode;
}

const SwitchInput = ({
  id,
  toolTip,
  disabled,
  checked,
  onChange,
  onClick,
  label,
}: SwitchInputProps) => {
  const switchContent = (
    <FormControlLabel
      className="form-theme-label"
      control={
        <Checkbox
          id={id}
          color="primary"
          checked={checked}
          onClick={onClick}
          onChange={onChange}
          data-testid={`test-${id}`}
          inputProps={{
            "aria-label": "primary checkbox",
          }}
          disabled={disabled}
        />
      }
      label={label}
    />
  );

  return toolTip ? (
    <Tooltip title={toolTip} placement="top">
      {switchContent}
    </Tooltip>
  ) : (
    switchContent
  );
};

export default SwitchInput;
